
export const ipfsCore = '0.16.1'
export const commit = 'd1f1e75b2060c5c2e64d133a7a6bbabd2641e5ef'
export const interfaceIpfsCore = '^0.156.1'
